import { apiGet, apiPost, apiPut, queryString, type ApiResult } from "./client";
import type { Group, GroupSaveResult, Lesson, Slot } from "./types";

export interface PlanFields {
  teacherId: string;
  classroomId: string;
  slots: Slot[];
}

export interface NewGroup extends PlanFields {
  name: string;
  courseId: string;
  note: string;
  startDate: string;
  endDate: string | null;
  confirm: boolean;
}

export interface PlanChange extends PlanFields {
  applyFrom: string;
  version: number;
  confirm: boolean;
  confirmOrphans: boolean;
}

export interface GroupIdentity {
  name: string;
  note: string;
  endDate: string | null;
  version: number;
  confirm: boolean;
  confirmOrphans: boolean;
}

export async function fetchGroups(includeArchived: boolean): Promise<ApiResult<Group[]>> {
  return apiGet<Group[]>("/groups" + queryString({ includeArchived }));
}

export async function fetchGroup(id: string): Promise<ApiResult<Group>> {
  return apiGet<Group>(`/groups/${id}`);
}

export async function createGroup(group: NewGroup): Promise<ApiResult<GroupSaveResult>> {
  return apiPost<GroupSaveResult>("/groups", group);
}

export async function changePlan(id: string, change: PlanChange): Promise<ApiResult<GroupSaveResult>> {
  return apiPost<GroupSaveResult>(`/groups/${id}/plan`, change);
}

export async function updateGroup(id: string, identity: GroupIdentity): Promise<ApiResult<Group | GroupSaveResult>> {
  return apiPut<Group | GroupSaveResult>(`/groups/${id}`, identity);
}

export async function setGroupArchived(id: string, archived: boolean, version: number): Promise<ApiResult<Group>> {
  const action: string = archived ? "archive" : "unarchive";
  return apiPost<Group>(`/groups/${id}/${action}`, { version });
}

export async function fetchGroupLessons(id: string, from: string, to: string): Promise<ApiResult<Lesson[]>> {
  return apiGet<Lesson[]>(`/groups/${id}/lessons` + queryString({ from, to }));
}
